export type ArtifactType = 'conversation' | 'audio-note' | 'insight'

export interface ParsedArtifactUrl {
  type: ArtifactType
  id: string
}

export function parseArtifactUrl(url: string): ParsedArtifactUrl | null {
  try {
    // Handle direct protocol URLs like CONVERSATION://id and AUDIO_NOTE://id
    if (url.startsWith('CONVERSATION://')) {
      return {
        type: 'conversation',
        id: url.replace('CONVERSATION://', ''),
      }
    }

    if (url.startsWith('AUDIO_NOTE://')) {
      return {
        type: 'audio-note',
        id: url.replace('AUDIO_NOTE://', ''),
      }
    }

    if (url.startsWith('INSIGHT://')) {
      return {
        type: 'insight',
        id: url.replace('INSIGHT://', ''),
      }
    }

    // Try parsing as regular URL
    const urlObj = new URL(url)

    if (urlObj.protocol === 'conversation:') {
      return {
        type: 'conversation',
        id: urlObj.pathname.replace('//', ''),
      }
    }

    if (urlObj.protocol === 'audio_note:') {
      return {
        type: 'audio-note',
        id: urlObj.pathname.replace('//', ''),
      }
    }

    if (urlObj.protocol === 'insight:') {
      return {
        type: 'insight',
        id: urlObj.pathname.replace('//', ''),
      }
    }

    return null
  } catch {
    return null
  }
}
